<template>
  <lsm-widget>
    <div
      v-if="welcomeText"
      class="text-start"
      v-html="welcomeText"
    />
  </lsm-widget>
</template>

<script setup lang="ts">
import LsmWidget from './LsmWidget.vue';

defineProps<{
  welcomeText: string;
}>();
</script>
